import { loadModal } from '../../AsyncLoader';
import Content from './ForgotPasswordModalContent';

const getModalBody = (emailAddress) => `
  <div class="tn-forgot-password-confirmation tn-success-message" id="tn-account-login-forgot-password-success-message">
    <div class="tn-forgot-password-confirmation__alert alert alert-info tn-modal-heading-info">
      <div class="tn-forgot-password-confirmation__message">${Content.successMessage}</div>
      <div>
        ${Content.emailAddressProvidedLabel}
        ${emailAddress}
      </div>
    </div>
  </div>
`;

async function open({ emailAddress, returnFocusTo }) {
  const Modal = await loadModal();

  Modal.alert({
    returnFocusTo,
    bodyContents: getModalBody(emailAddress),
    title: Content.successMessageSubhead,
    labelBtnAccept: Content.closeButtonText,
    describedById: "tn-forgot-password-confirmation-message"
  });
}

export default {
  open,
};
